import actionCreatorFactory from "typescript-fsa";

import { normalizeActions } from "@ea/shared_components/redux/common.actions";
import {
  createDataModuleActions,
  createTableActionsGetter,
} from "@ea/shared_components/redux/common.data.actions";
import { IssueTrackingToolRule } from "@ea/shared_types/types";

const actionCreator = actionCreatorFactory("ITS_RULES_MODULE");

export const moduleActions = createDataModuleActions<IssueTrackingToolRule>(actionCreator);
export const getItsRulesTableActions = createTableActionsGetter(
  normalizeActions(moduleActions.table),
);
export const itsRulesActions = {
  ...normalizeActions(moduleActions.data),
};
export const itsRulesActionCreators = {
  ...moduleActions,
};
